export default __webpack_public_path__ + "static/media/CAL80250.521527f9.jpg";